import React from 'react';

import { CustomerUpdate } from '../../types/Customer';

interface CustomerFormFieldsProps {
  formData: CustomerUpdate;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  phoneField: React.ReactNode;
}

const CustomerFormFields: React.FC<CustomerFormFieldsProps> = ({
  formData,
  onChange,
  phoneField,
}) => (
  <div className="customer-form-grid">
    <div className="customer-form-field">
      <label htmlFor="customer-name">Customer name *</label>
      <input id="customer-name" name="name" value={formData.name} onChange={onChange} />
    </div>
    <div className="customer-form-field">
      <label htmlFor="customer-email">Email ID</label>
      <input id="customer-email" name="email" value={formData.email || ''} onChange={onChange} />
    </div>
    <div className="customer-form-field">
      {phoneField}
    </div>
    <div className="customer-form-field">
      <label htmlFor="customer-address">Address</label>
      <input id="customer-address" name="address" value={formData.address} onChange={onChange} />
    </div>
    <div className="customer-form-field">
      <label htmlFor="customer-city">City</label>
      <input id="customer-city" name="city" value={formData.city} onChange={onChange} />
    </div>
    <div className="customer-form-field">
      <label htmlFor="customer-source">Source</label>
      <select id="customer-source" name="source" value={formData.source || ''} onChange={onChange}>
        <option value="">Select source</option>
        <option value="Just Dial">Just Dial</option>
        <option value="Social media">Social media</option>
        <option value="Website">Website</option>
        <option value="Market visit">Market visit</option>
      </select>
    </div>
    <div className="customer-form-field">
      <label htmlFor="customer-area">Area / source context</label>
      <input id="customer-area" name="area" value={formData.area || ''} onChange={onChange} />
    </div>
    <div className="customer-form-field">
      <label htmlFor="customer-profession">Profession</label>
      <input id="customer-profession" name="profession" value={formData.profession} onChange={onChange} />
    </div>
    <div className="customer-form-field customer-form-field--full">
      <label htmlFor="customer-description">Customer description</label>
      <textarea id="customer-description" name="description" value={formData.description || ''} onChange={onChange} />
    </div>
  </div>
);

export default CustomerFormFields;
